import { Navigate } from 'react-router-dom';

const WarehouseEdit = async () =>
    import('../../pages/warehouses/Edit').then((module) => ({ Component: module.WarehouseEdit }));

const getWarehouseRoutes = (user, _features) => {
    if (user.role === 'PROVIDER') {
        return [
            // Warehouses edit
            {
                path: '/warehouses/:warehouseId/edit',
                lazy: WarehouseEdit,
            },
            // Default
            {
                path: '/warehouses/*',
                element: <Navigate to='/' />,
            },
        ];
    } else {
        return [
            {
                path: '/warehouses/*',
                element: <Navigate to='/' />,
            },
        ];
    }
};

export { getWarehouseRoutes };
